import axios from 'axios'
import interceptor from './plugins/interceptor'
import defaultConfig from './defaults'
import api from './env.js'

export default class Api {
  constructor(opt) {
    this.config = Object.assign({
      baseURL: api[process.env.NODE_ENV]
    }, defaultConfig, opt)
    // 初始化axios实例
    this.$axios = axios.create(this.config)
    // 拦截请求
    this.$axios = interceptor(this.$axios, this.config)
    Array.of('get', 'post', 'delete', 'put', 'patch', 'request').map((item) => {
      this[item] = function(...args) {
        return this.$axios[item].apply(this.$axios, args)
      }
    })
  }
  createInstance(opt) { // 用于继承并重写，返回一个新的Api实例
    return new Api(Object.assign({}, this.config, opt))
  }
  client(route, opt) { // 用于继承，在url基础上拼接route，返回一个新的Api实例
    return this.createInstance(Object.assign({
      baseURL: `${this.config.baseURL}${route}`
    }, opt))
  }
}
